// src/features/staff/pages/StaffDetailsPage/components/StaffHeader.jsx

import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Chip,
  Button,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Block as BlockIcon,
  Security as SecurityIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { usePermissions } from '../../../../auth/hooks/usePermissions';
import { useNavigate } from 'react-router-dom';
import ProfilePicture from '../../../../../components/common/ProfilePicture';

import PageHeader from '../../../../../components/common/PageHeader';

export default function StaffHeader({ staffMember, staffRoles, onBack }) {
  const { t } = useTranslation(['staff']);
  const navigate = useNavigate()
  const permissions = usePermissions();

  const handleEdit = useCallback(() => {
    navigate(`/staff/${staffMember.staff_member_id}/edit`, { replace: true });
  }, [navigate, staffMember.staff_member_id]);

  // Check permissions
  const canUpdate = permissions.hasScope('staff:update');

  return (
    <PageHeader
      onBack={onBack}
      avatar={<>
        <ProfilePicture
          profilePictureFileId={staffMember?.profile_picture_file_id}
          name={staffMember?.name}
          size={40}
          color={staffMember?.color}
        />
      </>}
      title={staffMember.name}
      badges={<>
        <Chip
          icon={<SecurityIcon />}
          size="small"
          label={t('staff:roles_manager.assigned_count', { count: staffRoles.length })}
          color="secondary"
          variant="outlined"
        />
        <Chip
          icon={staffMember.is_active ? <CheckCircleIcon /> : <BlockIcon />}
          label={staffMember.is_active ? t('staff:status.active') : t('staff:status.inactive')}
          size="small"
          color={staffMember.is_active ? 'success' : 'warning'}
          variant="outlined"
        />
      </>}
      subtitle={t('staff:messages.staff_member_details_and_roles')}
      actions={<>
        {canUpdate && (
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={handleEdit}
          >
            {t('staff:edit_staff')}
          </Button>
        )}
      </>}
    />
  );
}